<template>
    <div class="container" v-if="creditMemo">
        <v-title :breadcrumb="breadcrumb">Credit Memo {{creditMemo.numberLabel}}</v-title>
        <div class="grid">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <div class="tile position-relative">
                            <v-inline-loader v-if="isLoading"/>
                            <div class="tile-content" v-else>
                                <credit-memo-context/>
                                <credit-memo-items/>
                                <div class="grid-content" v-fs-block>
                                    <credit-memo-allocations/>
                                    <credit-memo-transactions/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item grid-item-full">
                        <timeline
                            ref="timeline"
                            type="credit-memo"
                            :key="`customer-${creditMemo.customerId}-credit-memo-${creditMemo.id}-timeline`"
                            :entity="creditMemo"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vInlineLoader from '@/components/v-inline-loader';
    import CreditMemoAllocations from '@/modules/credit-memos/credit-memo-allocations';
    import CreditMemoContext from '@/modules/credit-memos/credit-memo-context';
    import CreditMemoItems from '@/modules/credit-memos/credit-memo-items';
    import CreditMemoTransactions from '@/modules/credit-memos/credit-memo-transactions';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import Timeline from '@/components/timeline/timeline';
    import {mapActions, mapState} from 'vuex';

    export default {
        name: 'credit-memo-details',
        components: {
            vTitle,
            vInlineLoader,
            CreditMemoContext,
            CreditMemoAllocations,
            CreditMemoItems,
            CreditMemoTransactions,
            Timeline,
        },
        mixins: [LoadStateMixin],
        props: {
            id: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            ...mapActions('creditMemos', ['fetchCreditMemo', 'fetchTransactions', 'fetchInvoices']),
            async fetchData() {
                this.isLoading = true;

                try {
                    await this.fetchCreditMemo(this.id);

                    const invoiceIds = this.creditMemo.allocations.map(allocation => allocation.invoiceId);

                    await Promise.all([
                        // fetch allocated invoices
                        this.fetchInvoices(invoiceIds),

                        // fetch transactions associated with this credit memo
                        this.fetchTransactions([
                            ...this.creditMemo.originTransactionIds,
                            ...this.creditMemo.reversalTransactionIds,
                            ...this.creditMemo.refundTransactionIds,
                        ]),
                    ]);
                } catch (error) {
                    this.$toast.fromError(error);
                } finally {
                    this.isLoading = false;
                }
            },
        },
        computed: {
            breadcrumb() {
                return {
                    label: 'Credit Memo Details',
                    route: {
                        name: 'credit-memo-details',
                        params: {
                            id: this.id,
                        },
                    },
                };
            },
            ...mapState('creditMemos', ['creditMemo']),
        },
    };
</script>
